import React from 'react';
import ImageTextBlock from './ImageTextBlock';

const Services: React.FC = () => (
  <section>
    <h2>Services</h2>
    <ImageTextBlock
      imageSrc="/images/colin_bench2.jpg"
      imageAlt="Collage of instruments for sale"
      text={
        <>
          In addition to making new instruments, I also offer repair and restoration services for both student and fine instruments.
          <br /><br />
          <strong>Services include:</strong>{' '}
          <a href="#basic-repairs">basic repairs</a> |{' '}
          <a href="#instrument-set-up">instrument set up</a> |{' '}
          <a href="#sound-adjustments">sound adjustments</a> |{' '}
          <a href="#restoration-services">restoration services</a> |{' '}
          <a href="#baroque-instruments">baroque instruments & violas da gamba</a>
        </>
      }
    />
 <h3 id="basic-repairs">Basic Repairs</h3>
    All kinds of small repairs can have a big effect on the look and feel of an instrument. I can clean and polish your instrument, touch up varnish, repair cracks and damage to all parts of the instrument, and replace and maintain basic components like bridges, soundposts, fingerboards, pegs, etc.
    <br /><br />

    <h3 id="instrument-set-up">Instrument Set Up</h3>
    If an instrument is uncomfortable or awkward to play, there are numerous ways in which I can improve the set up of the instrument. Often, an existing part simply needs a small adjustment rather than a complete replacement.
    <br /><br />

    <h3 id="sound-adjustments">Sound Adjustments</h3>
    Adjustments to an instrument’s sound post are an important part of customizing an instrument to a players style. I can also offer advice on how string choice, fittings, instrument set-up and other factors affect the sound.
    <br /><br />

    <h3 id="restoration-services">Restoration Services</h3>
    Fine restoration is the most demanding aspect of the luthier’s trade. Each restoration is unique, and my personal attention will assure you the highest quality results.
    <br /><br />

    <h3 id="baroque-instruments">Baroque Instruments & Violas da Gamba</h3>
    These early instruments demand a different approach from modern ones. I provide all the above listed services for early music clients, as well as handmade custom parts.


  </section>
);

export default Services;